import { Component } from '@angular/core';
import { ApiAuthService } from '@app/api';
import { AppLayoutSecureService } from '../../secure.service';

@Component({
  selector: 'app-layout-secure-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class AppLayoutSecureHeaderComponent {
  constructor(
    private _layoutSecure: AppLayoutSecureService,
    private _apiAuth: ApiAuthService,
  ) {}

  get user() {
    return this._apiAuth.user;
  }

  toggleMenu() {
    this._layoutSecure.toggleMenu();
  }

  logout() {
    this._layoutSecure.logout();
  }
}
